import { render, staticRenderFns } from "./sinCobertura.vue?vue&type=template&id=4dbb0f86&"
import script from "./sinCobertura.vue?vue&type=script&lang=js&"
export * from "./sinCobertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports